export default "__VITE_ASSET__DYCJI6hq__"